// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
    /* Color Palette - Zeit.de Style (Modern, Clean, Intelligent) */
    --bg-main: #fcfcfc;
    --bg-paper: #ffffff;
    --text-primary: #121212;
    --text-secondary: #555555;
    --text-muted: #888888;
    --accent: #ed3223;
    /* Classic Zeit/Tagesschau Red nuance */
    --accent-blue: #004b7c;
    /* Professional Blue */
    --glass-bg: rgba(255, 255, 255, 0.7);
    --glass-border: rgba(0, 0, 0, 0.08);
    --glass-blur: blur(10px);
    --border-light: #eeeeee;

    /* Typography */
    --font-serif: 'Lora', serif;
    --font-sans: 'Inter', sans-serif;

    /* Layout */
    --radius: 20px;
    /* Rounded corners */
    --radius-pill: 100px;
    --shadow-subtle: 0 4px 12px rgba(0, 0, 0, 0.05);
    --shadow-modal: 0 20px 40px rgba(0, 0, 0, 0.1);
}

* {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
    -webkit-font-smoothing: antialiased;
}

body {
    background-color: var(--bg-main);
    color: var(--text-primary);
    font-family: var(--font-sans);
    line-height: 1.6;
    min-height: 100vh;
    display: flex;
    flex-direction: column;
}

.lang-switcher {
    position: absolute;
    top: 2rem;
    right: 2rem;
    display: flex;
    gap: 0.75rem;
    z-index: 1000;
}

.lang-btn {
    background: var(--glass-bg);
    backdrop-filter: var(--glass-blur);
    border: 1px solid var(--glass-border);
    border-radius: 50%;
    width: 40px;
    height: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    font-size: 1.25rem;
    transition: all 0.3s ease;
    padding: 0;
}

.lang-btn:hover {
    transform: scale(1.1);
    box-shadow: var(--shadow-subtle);
}

.lang-btn.active {
    border-color: var(--accent-blue);
    background: #fff;
    box-shadow: 0 0 10px rgba(0, 102, 163, 0.2);
}

#app-container {
    width: 100%;
    max-width: 1200px;
    margin: 0 auto;
    padding: 3rem 2rem;
    flex: 1;
    display: flex;
    flex-direction: column;
}

/* ─── Tab navigation ───────────────────────────────── */
.tab-nav {
    display: flex;
    gap: 4px;
    justify-content: center;
    margin-bottom: 3rem;
    padding: 4px;
    background: var(--glass-bg);
    border: 1px solid var(--glass-border);
    border-radius: var(--radius-pill);
    width: fit-content;
    align-self: center;
    backdrop-filter: var(--glass-blur);
    position: relative;
    z-index: 1100;
    /* above the fixed #search-section (z-index: 1000) */
}

.tab-btn {
    background: none;
    border: none;
    border-radius: var(--radius-pill);
    padding: 0.55rem 1.5rem;
    font-family: var(--font-sans);
    font-size: 0.9rem;
    font-weight: 600;
    color: var(--text-muted);
    cursor: pointer;
    transition: color 0.2s, background 0.2s, box-shadow 0.2s;
}

.tab-btn:hover {
    color: var(--text-primary);
}

.tab-btn.active {
    background: var(--accent-blue);
    color: #fff;
    box-shadow: 0 2px 8px rgba(0, 75, 124, 0.25);
}

.tab-panel {
    display: none;
    flex-direction: column;
    flex: 1;
}

.tab-panel.active {
    display: flex;
    flex-direction: column;
}

/* ─── Speaker Calendar ──────────────────────────────── */
#tab-speakers {
    padding-top: 2rem;
}

#tab-transitions {
    padding-top: 2rem;
}

/* Shared expandable chart wrapper */
.chart-expandable {
    position: relative;
}

/* Expand to fullscreen button */
.chart-expand-btn {
    position: absolute;
    top: 10px;
    right: 10px;
    z-index: 20;
    background: var(--glass-bg);
    border: 1px solid var(--glass-border);
    border-radius: 8px;
    width: 30px;
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    font-size: 14px;
    color: var(--text-muted);
    transition: all 0.2s;
    backdrop-filter: var(--glass-blur);
    line-height: 1;
}

.chart-expand-btn:hover {
    color: var(--text-primary);
    border-color: var(--text-muted);
    background: #fff;
}

/* Info icon with CSS tooltip */
.chart-info-btn {
    position: absolute;
    top: 10px;
    right: 48px;
    z-index: 20;
    background: none;
    border: none;
    font-size: 15px;
    color: var(--text-muted);
    cursor: pointer;
    padding: 4px 6px;
    line-height: 1;
    transition: color 0.2s;
}

.chart-info-btn:hover {
    color: var(--accent-blue);
}

.chart-info-btn::after {
    content: attr(data-tooltip);
    position: absolute;
    right: 0;
    top: calc(100% + 8px);
    background: var(--text-primary);
    color: #fff;
    padding: 8px 12px;
    border-radius: 10px;
    font-family: var(--font-sans);
    font-size: 11px;
    font-weight: 400;
    line-height: 1.5;
    width: 230px;
    text-align: left;
    white-space: normal;
    opacity: 0;
    pointer-events: none;
    transition: opacity 0.18s;
    z-index: 100;
    box-shadow: var(--shadow-modal);
}

.chart-info-btn:hover::after {
    opacity: 1;
}

/* Fullscreen state — applied to the chart container element */
.chart-fullscreen {
    position: fixed !important;
    inset: 0 !important;
    width: 100vw !important;
    height: 100vh !important;
    max-width: none !important;
    border-radius: 0 !important;
    z-index: 9999 !important;
    overflow: auto !important;
    margin: 0 !important;
    padding: 3rem !important;
    background: var(--bg-main) !important;
    border: none !important;
}

/* Dim backdrop */
#fullscreen-backdrop {
    position: fixed;
    inset: 0;
    background: rgba(0, 0, 0, 0.45);
    z-index: 9998;
    backdrop-filter: blur(6px);
    animation: fadeIn 0.2s ease;
}

/* Floating close button */
#fullscreen-close {
    position: fixed;
    top: 16px;
    right: 16px;
    z-index: 10000;
    background: var(--bg-paper);
    border: 1px solid var(--glass-border);
    border-radius: 50%;
    width: 40px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    font-size: 1.3rem;
    color: var(--text-primary);
    transition: all 0.2s;
    box-shadow: var(--shadow-subtle);
}

#fullscreen-close:hover {
    background: var(--accent);
    color: #fff;
    border-color: var(--accent);
    transform: scale(1.05);
}

@keyframes fadeIn {
    from {
        opacity: 0;
    }

    to {
        opacity: 1;
    }
}

#transitions-graph {
    width: 100%;
    min-height: 720px;
    background: var(--glass-bg);
    border: 1px solid var(--glass-border);
    border-radius: var(--radius);
    backdrop-filter: var(--glass-blur);
    overflow: hidden;
    cursor: grab;
}

#transitions-graph:active {
    cursor: grabbing;
}

.transition-node {
    cursor: grab;
}

.transition-node:active {
    cursor: grabbing;
}

.speakers-header {
    text-align: center;
    margin-bottom: 2rem;
    color: var(--text-secondary);
    font-size: 1rem;
}

/* Sub-section heading inside a tab (e.g. between calendar & heatmap) */
.section-subheading {
    margin: 3rem 0 1.25rem;
    padding-bottom: 0.75rem;
    border-bottom: 1px solid var(--border-light);
}

.section-subheading h3 {
    font-family: var(--font-serif);
    font-size: 1.4rem;
    font-weight: 700;
    color: var(--text-primary);
    margin-bottom: 0.25rem;
}

.section-subheading-desc {
    font-size: 0.875rem;
    color: var(--text-muted);
}

/* Weekday Heatmap */
.weekday-heatmap-container {
    width: 100%;
    background: var(--glass-bg);
    border: 1px solid var(--glass-border);
    border-radius: var(--radius);
    backdrop-filter: var(--glass-blur);
    padding: 1.5rem 1.5rem 2rem;
    overflow-x: auto;
}

/* Mode toggle pill sitting above the SVG */
.heatmap-toggle {
    display: flex;
    gap: 4px;
    margin-bottom: 1rem;
    background: var(--border-light);
    border-radius: 100px;
    padding: 3px;
    width: fit-content;
}

.heatmap-toggle-btn {
    padding: 5px 16px;
    border: none;
    border-radius: 100px;
    font-family: var(--font-sans);
    font-size: 12px;
    font-weight: 600;
    cursor: pointer;
    background: transparent;
    color: var(--text-muted);
    transition: all 0.2s ease;
    white-space: nowrap;
}

.heatmap-toggle-btn.active {
    background: var(--accent-blue);
    color: #fff;
    box-shadow: 0 2px 6px rgba(0, 75, 124, 0.25);
}

.heatmap-toggle-btn:not(.active):hover {
    color: var(--text-primary);
}

/* Geo Slider Styling */
#geo-slider-container {
    flex: 1;
    min-width: 250px;
    height: 60px;
    margin-bottom: 1rem;
    position: relative;
}

#geo-map-wrapper .heatmap-toggle {
    margin-bottom: 0.5rem;
}

#geo-map-wrapper {
    display: flex;
    flex-direction: column;
}

@media (min-width: 768px) {
    #geo-map-wrapper .heatmap-toggle-row {
        display: flex;
        align-items: center;
        gap: 2rem;
        margin-bottom: 1.5rem;
    }

    #geo-map-wrapper .heatmap-toggle {
        margin-bottom: 0;
    }
}

.slider-axis path,
.slider-axis line {
    stroke: var(--border-light);
}

.slider-axis text {
    fill: var(--text-muted);
    font-size: 10px;
    font-family: var(--font-sans);
}

.slider-handle {
    fill: var(--accent-blue);
    stroke: #fff;
    stroke-width: 1.5px;
    cursor: ew-resize;
}

.slider-brush .selection {
    fill: var(--accent-blue);
    fill-opacity: 0.2;
    stroke: none;
}

.slider-label {
    fill: var(--text-primary);
    font-size: 11px;
    font-weight: 600;
    font-family: var(--font-sans);
    text-anchor: middle;
}

/* Data Coverage Chart */
#coverage-chart-wrapper {
    margin-top: 1rem;
    padding: 2rem;
}

#coverage-chart {
    width: 100%;
    height: 400px;
}

.speakers-legend {
    display: flex;
    flex-wrap: wrap;
    gap: 0.75rem 1.5rem;
    justify-content: center;
    margin-bottom: 2rem;
}

.legend-item {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    font-family: var(--font-sans);
    font-size: 0.85rem;
    font-weight: 500;
    color: var(--text-primary);
    cursor: pointer;
    padding: 4px 10px;
    border-radius: var(--radius-pill);
    border: 1.5px solid var(--glass-border);
    transition: all 0.2s;
}

.legend-item:hover {
    border-color: currentColor;
    background: var(--glass-bg);
}

.legend-item.dimmed {
    opacity: 0.3;
}

.legend-dot {
    width: 12px;
    height: 12px;
    border-radius: 50%;
    flex-shrink: 0;
}

.speakers-calendar {
    overflow-x: auto;
    padding-bottom: 1rem;
}

/* Calendar SVG overrides to match design system */
.speakers-calendar svg.month-svg {
    margin-right: 10px;
    margin-bottom: 30px;
    vertical-align: top;
}

.speakers-calendar .month-name {
    font-family: var(--font-sans);
    font-size: 11px;
    fill: var(--text-muted);
}

.speakers-calendar .day {
    cursor: pointer;
    transition: opacity 0.2s;
}

.speakers-calendar .day.hover {
    stroke: var(--text-primary);
    stroke-width: 1.5;
}

header {
    text-align: center;
    margin-bottom: 4rem;
}

.header-logo-row {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 1rem;
    margin-bottom: 0.5rem;
}

.header-logo {
    width: 36px;
    height: 36px;
    object-fit: contain;
    filter: drop-shadow(0 1px 4px rgba(0, 102, 163, 0.2));
    transition: transform 0.3s ease;
}

.header-logo:hover {
    transform: scale(1.08) rotate(-4deg);
}

header h1 {
    font-family: var(--font-serif);
    font-size: 4rem;
    font-weight: 700;
    color: var(--text-primary);
    letter-spacing: -0.02em;
    /* no margin-bottom here — the row handles spacing */
    margin-bottom: 0;
}

header p {
    color: var(--text-secondary);
    font-size: 1.125rem;
    font-weight: 400;
    letter-spacing: 0.05em;
    text-transform: uppercase;
}

.marker-highlight {
    position: relative;
    text-decoration: none;
    color: var(--text-primary);
    font-weight: 700;
    display: inline-block;
    padding: 0 4px;
}

.marker-highlight::after {
    content: "";
    position: absolute;
    left: -2%;
    bottom: 2px;
    width: 104%;
    height: 1.25em;
    background: var(--accent-blue);
    /* Tagesschau Blue */
    z-index: -1;
    transform: rotate(-1deg);
    opacity: 0.2;
    /* Light blue marker look */
    border-radius: 20% 80% 30% 70% / 10% 40% 60% 90%;
    /* Messy organic shape */
    transition: all 0.3s ease;
}

.marker-highlight:hover::after {
    opacity: 0.4;
    transform: rotate(0deg) scale(1.05);
}

/* Search Section - Centered & Airy */
#search-section {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 100%;
    max-width: 1050px;
    /* Wider layout */
    z-index: 1000;
    transition: all 0.7s cubic-bezier(0.4, 0, 0.2, 1);
}

#search-wrapper {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 3.5rem;
    /* Generous space between search bar and pills */
    align-items: center;
}

.search-top #search-section {
    position: relative;
    top: 0;
    left: 0;
    transform: none;
    margin: 0 auto 4rem;
    max-width: 100%;
}

.search-top header {
    transform: translateY(-20px);
    opacity: 0.5;
    margin-bottom: 1rem;
}

.search-top .header-logo {
    width: 36px;
    height: 36px;
}

.search-box {
    width: 100%;
    display: flex;
    background: var(--glass-bg);
    backdrop-filter: var(--glass-blur);
    border: 1px solid var(--glass-border);
    border-radius: var(--radius);
    padding: 8px;
    box-shadow: var(--shadow-subtle);
    transition: all 0.3s ease;
}

.search-box:focus-within {
    background: #fff;
    box-shadow: var(--shadow-modal);
    border-color: var(--text-primary);
}

.search-box input {
    flex: 1;
    background: transparent;
    border: none;
    padding: 16px 24px;
    color: var(--text-primary);
    font-size: 1.25rem;
    font-family: var(--font-serif);
    outline: none;
}

.search-box input::placeholder {
    color: var(--text-muted);
}

/* Centered Pill Tags */
.tags-list {
    display: flex;
    flex-wrap: wrap;
    gap: 0.75rem 1rem;
    justify-content: center;
    width: 100%;
}

.tag {
    display: flex;
    align-items: center;
    gap: 8px;
    background: var(--glass-bg);
    backdrop-filter: var(--glass-blur);
    padding: 4px 12px 4px 10px;
    border-radius: var(--radius-pill);
    font-family: var(--font-sans);
    font-size: 0.85rem;
    font-weight: 500;
    color: var(--text-primary);
    border: 1.5px solid var(--glass-border);
    transition: all 0.2s;
    cursor: default;
}

.tag:hover {
    border-color: var(--tag-color, var(--text-muted));
    background: var(--glass-bg);
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
}

.tag-color-dot {
    width: 10px;
    height: 10px;
    border-radius: 50%;
    flex-shrink: 0;
}

.tag-remove {
    cursor: pointer;
    font-size: 1rem;
    line-height: 1;
    color: var(--text-muted);
    transition: color 0.2s;
    display: flex;
    align-items: center;
    margin-left: 2px;
}

.tag-remove:hover {
    color: var(--accent);
}

/* Chart Container Card */
#chart-section {
    background: var(--glass-bg);
    backdrop-filter: var(--glass-blur);
    border: 1px solid var(--glass-border);
    border-radius: var(--radius);
    padding: 3rem;
    box-shadow: var(--shadow-subtle);
    opacity: 0;
    transform: translateY(30px);
    transition: all 0.8s cubic-bezier(0.16, 1, 0.3, 1);
}

#chart-section.visible {
    opacity: 1;
    transform: translateY(0);
}

.chart-header {
    margin-bottom: 3rem;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
}

.chart-header h2 {
    font-family: var(--font-serif);
    font-size: 2rem;
    font-weight: 700;
    color: var(--text-primary);
    position: relative;
}

.chart-header h2::after {
    content: '';
    display: block;
    width: 40px;
    height: 4px;
    background: var(--accent);
    margin-top: 10px;
}

#close-chart {
    background: transparent;
    border: none;
    color: var(--text-muted);
    cursor: pointer;
    width: 40px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.2s;
    font-size: 2rem;
}

#close-chart:hover {
    color: var(--text-primary);
}

#chart-container {
    width: 100%;
    height: 500px;
}

/* D3 Professional Visualization - Light Mode High Contrast */
.line {
    fill: none;
    stroke-width: 2;
    stroke-linecap: round;
}

.dot {
    cursor: pointer;
    stroke: #fff;
    stroke-width: 1.5px;
}

.dot:hover {
    r: 6;
    stroke-width: 2px;
}

.axis-label {
    fill: var(--text-muted);
    font-size: 0.85rem;
    font-family: var(--font-sans);
    font-weight: 500;
}

.grid line {
    stroke: #f0f0f0;
}

.tick text {
    fill: var(--text-secondary);
    font-size: 0.85rem;
    font-family: var(--font-sans);
    font-weight: 500;
}

.x-axis path,
.y-axis path {
    stroke: var(--border-light);
}

/* Brush Tool */
.brush .selection {
    fill: var(--text-primary);
    fill-opacity: 0.05;
    stroke: var(--text-primary);
    stroke-opacity: 0.2;
    stroke-width: 1px;
}

/* Loader Styling */
#loader {
    position: fixed;
    bottom: 3rem;
    right: 3rem;
    background: #fff;
    padding: 16px 32px;
    border-radius: var(--radius-pill);
    border: 1px solid var(--border-light);
    box-shadow: var(--shadow-modal);
    display: flex;
    align-items: center;
    gap: 1rem;
    z-index: 10000;
}

#loader p {
    font-weight: 600;
    color: var(--text-primary);
    font-size: 0.95rem;
}

.spinner {
    width: 18px;
    height: 18px;
    border: 2px solid #eee;
    border-top-color: var(--accent);
    border-radius: 50%;
    animation: spin 0.8s infinite linear;
}

.hidden {
    display: none !important;
}

@keyframes spin {
    to {
        transform: rotate(360deg);
    }
}

@media (max-width: 768px) {
    header h1 {
        font-size: 2.5rem;
    }

    #chart-section {
        padding: 1.5rem;
    }

    #chart-container {
        height: 350px;
    }
}

/* Footer Styles */
footer {
    margin-top: auto;
    padding: 2rem 0;
    /* Reduced height */
    border-top: 1px solid var(--border-light);
    color: var(--text-muted);
    font-size: 0.85rem;
}

.footer-grid {
    display: flex;
    justify-content: space-between;
    align-items: center;
    /* Centered vertically */
    gap: 2rem;
}

.footer-left p {
    margin-bottom: 0.25rem;
    /* Less space */
}

.footer-center {
    flex: 1;
    max-width: 400px;
}

.newsletter-input {
    border: 1px solid var(--glass-border);
    border-radius: var(--radius);
    /* Independent rounded borders */
    padding: 8px 16px;
    font-family: var(--font-sans);
    outline: none;
    width: 200px;
    transition: all 0.2s;
    margin-right: 8px;
    /* Added space between united group items earlier? No, let's separate them if we want 'same borders' */
}

.newsletter-input:focus {
    border-color: var(--text-primary);
}

.btn-subscribe {
    background: var(--accent-blue);
    color: white;
    border: 1px solid var(--accent-blue);
    border-radius: var(--radius);
    padding: 8px 20px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.2s;
}

.btn-subscribe:hover {
    background: #003a61;
}

.dsgvo-wrapper {
    margin-top: 8px;
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 0.8rem;
}

.dsgvo-link {
    text-decoration: underline;
    cursor: pointer;
}

/* Modal Styling */
.custom-modal {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.4);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 10000;
}

.custom-modal .modal-content {
    background: white;
    padding: 2rem;
    border-radius: var(--radius);
    max-width: 500px;
    width: 90%;
    box-shadow: var(--shadow-modal);
}

.subtitle-modal-content {
    max-width: 800px !important;
    max-height: 80vh;
    display: flex;
    flex-direction: column;
}

.subtitle-body {
    overflow-y: auto;
    font-family: var(--font-sans);
    line-height: 1.8;
    font-size: 1.1rem;
    color: var(--text-primary);
    padding-right: 1rem;
}

/* Marker highlight within subtitle text */
.text-marker {
    position: relative;
    padding: 0 4px;
    font-weight: 700;
    z-index: 1;
}

.text-marker::after {
    content: "";
    position: absolute;
    left: -2px;
    bottom: 0px;
    width: calc(100% + 4px);
    height: 1.2em;
    background: var(--accent-blue);
    opacity: 0.25;
    z-index: -1;
    transform: rotate(-0.5deg);
    border-radius: 2px 4px 1px 3px;
}

.modal-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 1.5rem;
}

.btn-close {
    background: none;
    border: none;
    font-size: 2rem;
    cursor: pointer;
    color: var(--text-muted);
}

.author-link {
    color: var(--text-primary);
    text-decoration: none;
    font-weight: 600;
}

.author-link:hover {
    text-decoration: underline;
}

.disclaimer {
    font-style: italic;
    font-size: 0.75rem;
}

.text-muted {
    font-family: var(--font-sans);
    line-height: 1.6;
}

.text-muted b {
    color: var(--text-secondary);
}

.text-muted a {
    color: var(--text-muted);
    text-decoration: underline;
    text-underline-offset: 2px;
}

.text-muted a:hover {
    color: var(--accent-blue);
}

@media (max-width: 900px) {
    .footer-grid {
        flex-direction: column;
        text-align: center;
        gap: 1.5rem;
    }

    .footer-center {
        max-width: 100%;
    }
}`, "",{"version":3,"sources":["webpack://./src/style.css"],"names":[],"mappings":"AAAA;IACI,+DAA+D;IAC/D,kBAAkB;IAClB,mBAAmB;IACnB,uBAAuB;IACvB,yBAAyB;IACzB,qBAAqB;IACrB,iBAAiB;IACjB,uCAAuC;IACvC,sBAAsB;IACtB,sBAAsB;IACtB,oCAAoC;IACpC,mCAAmC;IACnC,wBAAwB;IACxB,uBAAuB;;IAEvB,eAAe;IACf,2BAA2B;IAC3B,gCAAgC;;IAEhC,WAAW;IACX,cAAc;IACd,oBAAoB;IACpB,oBAAoB;IACpB,+CAA+C;IAC/C,8CAA8C;AAClD;;AAEA;IACI,sBAAsB;IACtB,SAAS;IACT,UAAU;IACV,mCAAmC;AACvC;;AAEA;IACI,gCAAgC;IAChC,0BAA0B;IAC1B,6BAA6B;IAC7B,gBAAgB;IAChB,iBAAiB;IACjB,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,aAAa;IACb,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,2BAA2B;IAC3B,kCAAkC;IAClC,qCAAqC;IACrC,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;IACf,kBAAkB;IAClB,yBAAyB;IACzB,UAAU;AACd;;AAEA;IACI,qBAAqB;IACrB,gCAAgC;AACpC;;AAEA;IACI,gCAAgC;IAChC,gBAAgB;IAChB,2CAA2C;AAC/C;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,cAAc;IACd,kBAAkB;IAClB,OAAO;IACP,aAAa;IACb,sBAAsB;AAC1B;;AAEA,yDAAyD;AACzD;IACI,aAAa;IACb,QAAQ;IACR,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;IACZ,2BAA2B;IAC3B,qCAAqC;IACrC,iCAAiC;IACjC,kBAAkB;IAClB,kBAAkB;IAClB,kCAAkC;IAClC,kBAAkB;IAClB,aAAa;IACb,oDAAoD;AACxD;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,iCAAiC;IACjC,uBAAuB;IACvB,6BAA6B;IAC7B,iBAAiB;IACjB,gBAAgB;IAChB,wBAAwB;IACxB,eAAe;IACf,wDAAwD;AAC5D;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,8BAA8B;IAC9B,WAAW;IACX,4CAA4C;AAChD;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,OAAO;AACX;;AAEA;IACI,aAAa;IACb,sBAAsB;AAC1B;;AAEA,0DAA0D;AAC1D;IACI,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;AACrB;;AAEA,oCAAoC;AACpC;IACI,kBAAkB;AACtB;;AAEA,gCAAgC;AAChC;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,WAAW;IACX,2BAA2B;IAC3B,qCAAqC;IACrC,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,eAAe;IACf,wBAAwB;IACxB,oBAAoB;IACpB,kCAAkC;IAClC,cAAc;AAClB;;AAEA;IACI,0BAA0B;IAC1B,+BAA+B;IAC/B,gBAAgB;AACpB;;AAEA,+BAA+B;AAC/B;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,WAAW;IACX,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,wBAAwB;IACxB,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,sBAAsB;AAC1B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,2BAA2B;IAC3B,kBAAkB;IAClB,QAAQ;IACR,qBAAqB;IACrB,+BAA+B;IAC/B,WAAW;IACX,iBAAiB;IACjB,mBAAmB;IACnB,6BAA6B;IAC7B,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,YAAY;IACZ,gBAAgB;IAChB,mBAAmB;IACnB,UAAU;IACV,oBAAoB;IACpB,yBAAyB;IACzB,YAAY;IACZ,+BAA+B;AACnC;;AAEA;IACI,UAAU;AACd;;AAEA,8DAA8D;AAC9D;IACI,0BAA0B;IAC1B,mBAAmB;IACnB,uBAAuB;IACvB,wBAAwB;IACxB,0BAA0B;IAC1B,2BAA2B;IAC3B,wBAAwB;IACxB,yBAAyB;IACzB,oBAAoB;IACpB,wBAAwB;IACxB,qCAAqC;IACrC,uBAAuB;AAC3B;;AAEA,iBAAiB;AACjB;IACI,eAAe;IACf,QAAQ;IACR,+BAA+B;IAC/B,aAAa;IACb,0BAA0B;IAC1B,2BAA2B;AAC/B;;AAEA,0BAA0B;AAC1B;IACI,eAAe;IACf,SAAS;IACT,WAAW;IACX,cAAc;IACd,2BAA2B;IAC3B,qCAAqC;IACrC,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,iBAAiB;IACjB,0BAA0B;IAC1B,oBAAoB;IACpB,gCAAgC;AACpC;;AAEA;IACI,yBAAyB;IACzB,WAAW;IACX,2BAA2B;IAC3B,sBAAsB;AAC1B;;AAEA;IACI;QACI,UAAU;IACd;;IAEA;QACI,UAAU;IACd;AACJ;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,2BAA2B;IAC3B,qCAAqC;IACrC,4BAA4B;IAC5B,kCAAkC;IAClC,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,4BAA4B;IAC5B,eAAe;AACnB;;AAEA,uEAAuE;AACvE;IACI,sBAAsB;IACtB,uBAAuB;IACvB,4CAA4C;AAChD;;AAEA;IACI,8BAA8B;IAC9B,iBAAiB;IACjB,gBAAgB;IAChB,0BAA0B;IAC1B,sBAAsB;AAC1B;;AAEA;IACI,mBAAmB;IACnB,wBAAwB;AAC5B;;AAEA,oBAAoB;AACpB;IACI,WAAW;IACX,2BAA2B;IAC3B,qCAAqC;IACrC,4BAA4B;IAC5B,kCAAkC;IAClC,2BAA2B;IAC3B,gBAAgB;AACpB;;AAEA,2CAA2C;AAC3C;IACI,aAAa;IACb,QAAQ;IACR,mBAAmB;IACnB,+BAA+B;IAC/B,oBAAoB;IACpB,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,YAAY;IACZ,oBAAoB;IACpB,6BAA6B;IAC7B,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,uBAAuB;IACvB,wBAAwB;IACxB,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;IAC9B,WAAW;IACX,4CAA4C;AAChD;;AAEA;IACI,0BAA0B;AAC9B;;AAEA,uBAAuB;AACvB;IACI,OAAO;IACP,gBAAgB;IAChB,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI;QACI,aAAa;QACb,mBAAmB;QACnB,SAAS;QACT,qBAAqB;IACzB;;IAEA;QACI,gBAAgB;IACpB;AACJ;;AAEA;;IAEI,2BAA2B;AAC/B;;AAEA;IACI,uBAAuB;IACvB,eAAe;IACf,6BAA6B;AACjC;;AAEA;IACI,wBAAwB;IACxB,YAAY;IACZ,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,wBAAwB;IACxB,iBAAiB;IACjB,YAAY;AAChB;;AAEA;IACI,yBAAyB;IACzB,eAAe;IACf,gBAAgB;IAChB,6BAA6B;IAC7B,mBAAmB;AACvB;;AAEA,wBAAwB;AACxB;IACI,gBAAgB;IAChB,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,6BAA6B;IAC7B,kBAAkB;IAClB,gBAAgB;IAChB,0BAA0B;IAC1B,eAAe;IACf,iBAAiB;IACjB,iCAAiC;IACjC,uCAAuC;IACvC,oBAAoB;AACxB;;AAEA;IACI,0BAA0B;IAC1B,2BAA2B;AAC/B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,oBAAoB;AACxB;;AAEA,kDAAkD;AAClD;IACI,kBAAkB;IAClB,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,6BAA6B;IAC7B,eAAe;IACf,uBAAuB;AAC3B;;AAEA;IACI,eAAe;IACf,wBAAwB;AAC5B;;AAEA;IACI,2BAA2B;IAC3B,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,SAAS;IACT,qBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,qDAAqD;IACrD,+BAA+B;AACnC;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,8BAA8B;IAC9B,eAAe;IACf,gBAAgB;IAChB,0BAA0B;IAC1B,uBAAuB;IACvB,oDAAoD;IACpD,gBAAgB;AACpB;;AAEA;IACI,4BAA4B;IAC5B,mBAAmB;IACnB,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,qBAAqB;IACrB,0BAA0B;IAC1B,gBAAgB;IAChB,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,WAAW;IACX,cAAc;IACd,8BAA8B;IAC9B,oBAAoB;IACpB,WAAW;IACX,wBAAwB;IACxB,YAAY;IACZ,2BAA2B;IAC3B,gDAAgD;IAChD,wBAAwB;IACxB,yBAAyB;AAC7B;;AAEA;IACI,YAAY;IACZ,mCAAmC;AACvC;;AAEA,qCAAqC;AACrC;IACI,eAAe;IACf,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,WAAW;IACX,iBAAiB;IACjB,iBAAiB;IACjB,aAAa;IACb,iDAAiD;AACrD;;AAEA;IACI,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,gDAAgD;IAChD,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,eAAe;IACf,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,4BAA4B;IAC5B,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,2BAA2B;IAC3B,kCAAkC;IAClC,qCAAqC;IACrC,4BAA4B;IAC5B,YAAY;IACZ,gCAAgC;IAChC,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;IAChB,+BAA+B;IAC/B,iCAAiC;AACrC;;AAEA;IACI,OAAO;IACP,uBAAuB;IACvB,YAAY;IACZ,kBAAkB;IAClB,0BAA0B;IAC1B,kBAAkB;IAClB,8BAA8B;IAC9B,aAAa;AACjB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA,uBAAuB;AACvB;IACI,aAAa;IACb,eAAe;IACf,iBAAiB;IACjB,uBAAuB;IACvB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,2BAA2B;IAC3B,kCAAkC;IAClC,0BAA0B;IAC1B,iCAAiC;IACjC,6BAA6B;IAC7B,kBAAkB;IAClB,gBAAgB;IAChB,0BAA0B;IAC1B,uCAAuC;IACvC,oBAAoB;IACpB,eAAe;AACnB;;AAEA;IACI,iDAAiD;IACjD,2BAA2B;IAC3B,yCAAyC;AAC7C;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,eAAe;IACf,cAAc;IACd,wBAAwB;IACxB,sBAAsB;IACtB,aAAa;IACb,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,oBAAoB;AACxB;;AAEA,yBAAyB;AACzB;IACI,2BAA2B;IAC3B,kCAAkC;IAClC,qCAAqC;IACrC,4BAA4B;IAC5B,aAAa;IACb,gCAAgC;IAChC,UAAU;IACV,2BAA2B;IAC3B,kDAAkD;AACtD;;AAEA;IACI,UAAU;IACV,wBAAwB;AAC5B;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,8BAA8B;IAC9B,uBAAuB;AAC3B;;AAEA;IACI,8BAA8B;IAC9B,eAAe;IACf,gBAAgB;IAChB,0BAA0B;IAC1B,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,cAAc;IACd,WAAW;IACX,WAAW;IACX,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;IACI,uBAAuB;IACvB,YAAY;IACZ,wBAAwB;IACxB,eAAe;IACf,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,oBAAoB;IACpB,eAAe;AACnB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,WAAW;IACX,aAAa;AACjB;;AAEA,6DAA6D;AAC7D;IACI,UAAU;IACV,eAAe;IACf,qBAAqB;AACzB;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,IAAI;IACJ,iBAAiB;AACrB;;AAEA;IACI,uBAAuB;IACvB,kBAAkB;IAClB,6BAA6B;IAC7B,gBAAgB;AACpB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,2BAA2B;IAC3B,kBAAkB;IAClB,6BAA6B;IAC7B,gBAAgB;AACpB;;AAEA;;IAEI,2BAA2B;AAC/B;;AAEA,eAAe;AACf;IACI,yBAAyB;IACzB,kBAAkB;IAClB,2BAA2B;IAC3B,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA,mBAAmB;AACnB;IACI,eAAe;IACf,YAAY;IACZ,WAAW;IACX,gBAAgB;IAChB,kBAAkB;IAClB,iCAAiC;IACjC,qCAAqC;IACrC,+BAA+B;IAC/B,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,0BAA0B;IAC1B,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,sBAAsB;IACtB,+BAA+B;IAC/B,kBAAkB;IAClB,oCAAoC;AACxC;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI;QACI,yBAAyB;IAC7B;AACJ;;AAEA;IACI;QACI,iBAAiB;IACrB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,aAAa;IACjB;AACJ;;AAEA,kBAAkB;AAClB;IACI,gBAAgB;IAChB,eAAe;IACf,mBAAmB;IACnB,yCAAyC;IACzC,wBAAwB;IACxB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,wBAAwB;IACxB,SAAS;AACb;;AAEA;IACI,sBAAsB;IACtB,eAAe;AACnB;;AAEA;IACI,OAAO;IACP,gBAAgB;AACpB;;AAEA;IACI,qCAAqC;IACrC,4BAA4B;IAC5B,gCAAgC;IAChC,iBAAiB;IACjB,6BAA6B;IAC7B,aAAa;IACb,YAAY;IACZ,oBAAoB;IACpB,iBAAiB;IACjB,sGAAsG;AAC1G;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,8BAA8B;IAC9B,YAAY;IACZ,oCAAoC;IACpC,4BAA4B;IAC5B,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;IACf,oBAAoB;AACxB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,iBAAiB;AACrB;;AAEA;IACI,0BAA0B;IAC1B,eAAe;AACnB;;AAEA,kBAAkB;AAClB;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,8BAA8B;IAC9B,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,aAAa;IACb,4BAA4B;IAC5B,gBAAgB;IAChB,UAAU;IACV,+BAA+B;AACnC;;AAEA;IACI,2BAA2B;IAC3B,gBAAgB;IAChB,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;IAChB,6BAA6B;IAC7B,gBAAgB;IAChB,iBAAiB;IACjB,0BAA0B;IAC1B,mBAAmB;AACvB;;AAEA,0CAA0C;AAC1C;IACI,kBAAkB;IAClB,cAAc;IACd,gBAAgB;IAChB,UAAU;AACd;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,uBAAuB;IACvB,aAAa;IACb,8BAA8B;IAC9B,aAAa;IACb,WAAW;IACX,0BAA0B;IAC1B,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,eAAe;IACf,wBAAwB;AAC5B;;AAEA;IACI,0BAA0B;IAC1B,qBAAqB;IACrB,gBAAgB;AACpB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,6BAA6B;IAC7B,gBAAgB;AACpB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,wBAAwB;IACxB,0BAA0B;IAC1B,0BAA0B;AAC9B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI;QACI,sBAAsB;QACtB,kBAAkB;QAClB,WAAW;IACf;;IAEA;QACI,eAAe;IACnB;AACJ","sourcesContent":[":root {\n    /* Color Palette - Zeit.de Style (Modern, Clean, Intelligent) */\n    --bg-main: #fcfcfc;\n    --bg-paper: #ffffff;\n    --text-primary: #121212;\n    --text-secondary: #555555;\n    --text-muted: #888888;\n    --accent: #ed3223;\n    /* Classic Zeit/Tagesschau Red nuance */\n    --accent-blue: #004b7c;\n    /* Professional Blue */\n    --glass-bg: rgba(255, 255, 255, 0.7);\n    --glass-border: rgba(0, 0, 0, 0.08);\n    --glass-blur: blur(10px);\n    --border-light: #eeeeee;\n\n    /* Typography */\n    --font-serif: 'Lora', serif;\n    --font-sans: 'Inter', sans-serif;\n\n    /* Layout */\n    --radius: 20px;\n    /* Rounded corners */\n    --radius-pill: 100px;\n    --shadow-subtle: 0 4px 12px rgba(0, 0, 0, 0.05);\n    --shadow-modal: 0 20px 40px rgba(0, 0, 0, 0.1);\n}\n\n* {\n    box-sizing: border-box;\n    margin: 0;\n    padding: 0;\n    -webkit-font-smoothing: antialiased;\n}\n\nbody {\n    background-color: var(--bg-main);\n    color: var(--text-primary);\n    font-family: var(--font-sans);\n    line-height: 1.6;\n    min-height: 100vh;\n    display: flex;\n    flex-direction: column;\n}\n\n.lang-switcher {\n    position: absolute;\n    top: 2rem;\n    right: 2rem;\n    display: flex;\n    gap: 0.75rem;\n    z-index: 1000;\n}\n\n.lang-btn {\n    background: var(--glass-bg);\n    backdrop-filter: var(--glass-blur);\n    border: 1px solid var(--glass-border);\n    border-radius: 50%;\n    width: 40px;\n    height: 40px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    cursor: pointer;\n    font-size: 1.25rem;\n    transition: all 0.3s ease;\n    padding: 0;\n}\n\n.lang-btn:hover {\n    transform: scale(1.1);\n    box-shadow: var(--shadow-subtle);\n}\n\n.lang-btn.active {\n    border-color: var(--accent-blue);\n    background: #fff;\n    box-shadow: 0 0 10px rgba(0, 102, 163, 0.2);\n}\n\n#app-container {\n    width: 100%;\n    max-width: 1200px;\n    margin: 0 auto;\n    padding: 3rem 2rem;\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n}\n\n/* ─── Tab navigation ───────────────────────────────── */\n.tab-nav {\n    display: flex;\n    gap: 4px;\n    justify-content: center;\n    margin-bottom: 3rem;\n    padding: 4px;\n    background: var(--glass-bg);\n    border: 1px solid var(--glass-border);\n    border-radius: var(--radius-pill);\n    width: fit-content;\n    align-self: center;\n    backdrop-filter: var(--glass-blur);\n    position: relative;\n    z-index: 1100;\n    /* above the fixed #search-section (z-index: 1000) */\n}\n\n.tab-btn {\n    background: none;\n    border: none;\n    border-radius: var(--radius-pill);\n    padding: 0.55rem 1.5rem;\n    font-family: var(--font-sans);\n    font-size: 0.9rem;\n    font-weight: 600;\n    color: var(--text-muted);\n    cursor: pointer;\n    transition: color 0.2s, background 0.2s, box-shadow 0.2s;\n}\n\n.tab-btn:hover {\n    color: var(--text-primary);\n}\n\n.tab-btn.active {\n    background: var(--accent-blue);\n    color: #fff;\n    box-shadow: 0 2px 8px rgba(0, 75, 124, 0.25);\n}\n\n.tab-panel {\n    display: none;\n    flex-direction: column;\n    flex: 1;\n}\n\n.tab-panel.active {\n    display: flex;\n    flex-direction: column;\n}\n\n/* ─── Speaker Calendar ──────────────────────────────── */\n#tab-speakers {\n    padding-top: 2rem;\n}\n\n#tab-transitions {\n    padding-top: 2rem;\n}\n\n/* Shared expandable chart wrapper */\n.chart-expandable {\n    position: relative;\n}\n\n/* Expand to fullscreen button */\n.chart-expand-btn {\n    position: absolute;\n    top: 10px;\n    right: 10px;\n    z-index: 20;\n    background: var(--glass-bg);\n    border: 1px solid var(--glass-border);\n    border-radius: 8px;\n    width: 30px;\n    height: 30px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    cursor: pointer;\n    font-size: 14px;\n    color: var(--text-muted);\n    transition: all 0.2s;\n    backdrop-filter: var(--glass-blur);\n    line-height: 1;\n}\n\n.chart-expand-btn:hover {\n    color: var(--text-primary);\n    border-color: var(--text-muted);\n    background: #fff;\n}\n\n/* Info icon with CSS tooltip */\n.chart-info-btn {\n    position: absolute;\n    top: 10px;\n    right: 48px;\n    z-index: 20;\n    background: none;\n    border: none;\n    font-size: 15px;\n    color: var(--text-muted);\n    cursor: pointer;\n    padding: 4px 6px;\n    line-height: 1;\n    transition: color 0.2s;\n}\n\n.chart-info-btn:hover {\n    color: var(--accent-blue);\n}\n\n.chart-info-btn::after {\n    content: attr(data-tooltip);\n    position: absolute;\n    right: 0;\n    top: calc(100% + 8px);\n    background: var(--text-primary);\n    color: #fff;\n    padding: 8px 12px;\n    border-radius: 10px;\n    font-family: var(--font-sans);\n    font-size: 11px;\n    font-weight: 400;\n    line-height: 1.5;\n    width: 230px;\n    text-align: left;\n    white-space: normal;\n    opacity: 0;\n    pointer-events: none;\n    transition: opacity 0.18s;\n    z-index: 100;\n    box-shadow: var(--shadow-modal);\n}\n\n.chart-info-btn:hover::after {\n    opacity: 1;\n}\n\n/* Fullscreen state — applied to the chart container element */\n.chart-fullscreen {\n    position: fixed !important;\n    inset: 0 !important;\n    width: 100vw !important;\n    height: 100vh !important;\n    max-width: none !important;\n    border-radius: 0 !important;\n    z-index: 9999 !important;\n    overflow: auto !important;\n    margin: 0 !important;\n    padding: 3rem !important;\n    background: var(--bg-main) !important;\n    border: none !important;\n}\n\n/* Dim backdrop */\n#fullscreen-backdrop {\n    position: fixed;\n    inset: 0;\n    background: rgba(0, 0, 0, 0.45);\n    z-index: 9998;\n    backdrop-filter: blur(6px);\n    animation: fadeIn 0.2s ease;\n}\n\n/* Floating close button */\n#fullscreen-close {\n    position: fixed;\n    top: 16px;\n    right: 16px;\n    z-index: 10000;\n    background: var(--bg-paper);\n    border: 1px solid var(--glass-border);\n    border-radius: 50%;\n    width: 40px;\n    height: 40px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    cursor: pointer;\n    font-size: 1.3rem;\n    color: var(--text-primary);\n    transition: all 0.2s;\n    box-shadow: var(--shadow-subtle);\n}\n\n#fullscreen-close:hover {\n    background: var(--accent);\n    color: #fff;\n    border-color: var(--accent);\n    transform: scale(1.05);\n}\n\n@keyframes fadeIn {\n    from {\n        opacity: 0;\n    }\n\n    to {\n        opacity: 1;\n    }\n}\n\n#transitions-graph {\n    width: 100%;\n    min-height: 720px;\n    background: var(--glass-bg);\n    border: 1px solid var(--glass-border);\n    border-radius: var(--radius);\n    backdrop-filter: var(--glass-blur);\n    overflow: hidden;\n    cursor: grab;\n}\n\n#transitions-graph:active {\n    cursor: grabbing;\n}\n\n.transition-node {\n    cursor: grab;\n}\n\n.transition-node:active {\n    cursor: grabbing;\n}\n\n.speakers-header {\n    text-align: center;\n    margin-bottom: 2rem;\n    color: var(--text-secondary);\n    font-size: 1rem;\n}\n\n/* Sub-section heading inside a tab (e.g. between calendar & heatmap) */\n.section-subheading {\n    margin: 3rem 0 1.25rem;\n    padding-bottom: 0.75rem;\n    border-bottom: 1px solid var(--border-light);\n}\n\n.section-subheading h3 {\n    font-family: var(--font-serif);\n    font-size: 1.4rem;\n    font-weight: 700;\n    color: var(--text-primary);\n    margin-bottom: 0.25rem;\n}\n\n.section-subheading-desc {\n    font-size: 0.875rem;\n    color: var(--text-muted);\n}\n\n/* Weekday Heatmap */\n.weekday-heatmap-container {\n    width: 100%;\n    background: var(--glass-bg);\n    border: 1px solid var(--glass-border);\n    border-radius: var(--radius);\n    backdrop-filter: var(--glass-blur);\n    padding: 1.5rem 1.5rem 2rem;\n    overflow-x: auto;\n}\n\n/* Mode toggle pill sitting above the SVG */\n.heatmap-toggle {\n    display: flex;\n    gap: 4px;\n    margin-bottom: 1rem;\n    background: var(--border-light);\n    border-radius: 100px;\n    padding: 3px;\n    width: fit-content;\n}\n\n.heatmap-toggle-btn {\n    padding: 5px 16px;\n    border: none;\n    border-radius: 100px;\n    font-family: var(--font-sans);\n    font-size: 12px;\n    font-weight: 600;\n    cursor: pointer;\n    background: transparent;\n    color: var(--text-muted);\n    transition: all 0.2s ease;\n    white-space: nowrap;\n}\n\n.heatmap-toggle-btn.active {\n    background: var(--accent-blue);\n    color: #fff;\n    box-shadow: 0 2px 6px rgba(0, 75, 124, 0.25);\n}\n\n.heatmap-toggle-btn:not(.active):hover {\n    color: var(--text-primary);\n}\n\n/* Geo Slider Styling */\n#geo-slider-container {\n    flex: 1;\n    min-width: 250px;\n    height: 60px;\n    margin-bottom: 1rem;\n    position: relative;\n}\n\n#geo-map-wrapper .heatmap-toggle {\n    margin-bottom: 0.5rem;\n}\n\n#geo-map-wrapper {\n    display: flex;\n    flex-direction: column;\n}\n\n@media (min-width: 768px) {\n    #geo-map-wrapper .heatmap-toggle-row {\n        display: flex;\n        align-items: center;\n        gap: 2rem;\n        margin-bottom: 1.5rem;\n    }\n\n    #geo-map-wrapper .heatmap-toggle {\n        margin-bottom: 0;\n    }\n}\n\n.slider-axis path,\n.slider-axis line {\n    stroke: var(--border-light);\n}\n\n.slider-axis text {\n    fill: var(--text-muted);\n    font-size: 10px;\n    font-family: var(--font-sans);\n}\n\n.slider-handle {\n    fill: var(--accent-blue);\n    stroke: #fff;\n    stroke-width: 1.5px;\n    cursor: ew-resize;\n}\n\n.slider-brush .selection {\n    fill: var(--accent-blue);\n    fill-opacity: 0.2;\n    stroke: none;\n}\n\n.slider-label {\n    fill: var(--text-primary);\n    font-size: 11px;\n    font-weight: 600;\n    font-family: var(--font-sans);\n    text-anchor: middle;\n}\n\n/* Data Coverage Chart */\n#coverage-chart-wrapper {\n    margin-top: 1rem;\n    padding: 2rem;\n}\n\n#coverage-chart {\n    width: 100%;\n    height: 400px;\n}\n\n.speakers-legend {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 0.75rem 1.5rem;\n    justify-content: center;\n    margin-bottom: 2rem;\n}\n\n.legend-item {\n    display: flex;\n    align-items: center;\n    gap: 0.5rem;\n    font-family: var(--font-sans);\n    font-size: 0.85rem;\n    font-weight: 500;\n    color: var(--text-primary);\n    cursor: pointer;\n    padding: 4px 10px;\n    border-radius: var(--radius-pill);\n    border: 1.5px solid var(--glass-border);\n    transition: all 0.2s;\n}\n\n.legend-item:hover {\n    border-color: currentColor;\n    background: var(--glass-bg);\n}\n\n.legend-item.dimmed {\n    opacity: 0.3;\n}\n\n.legend-dot {\n    width: 12px;\n    height: 12px;\n    border-radius: 50%;\n    flex-shrink: 0;\n}\n\n.speakers-calendar {\n    overflow-x: auto;\n    padding-bottom: 1rem;\n}\n\n/* Calendar SVG overrides to match design system */\n.speakers-calendar svg.month-svg {\n    margin-right: 10px;\n    margin-bottom: 30px;\n    vertical-align: top;\n}\n\n.speakers-calendar .month-name {\n    font-family: var(--font-sans);\n    font-size: 11px;\n    fill: var(--text-muted);\n}\n\n.speakers-calendar .day {\n    cursor: pointer;\n    transition: opacity 0.2s;\n}\n\n.speakers-calendar .day.hover {\n    stroke: var(--text-primary);\n    stroke-width: 1.5;\n}\n\nheader {\n    text-align: center;\n    margin-bottom: 4rem;\n}\n\n.header-logo-row {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 1rem;\n    margin-bottom: 0.5rem;\n}\n\n.header-logo {\n    width: 36px;\n    height: 36px;\n    object-fit: contain;\n    filter: drop-shadow(0 1px 4px rgba(0, 102, 163, 0.2));\n    transition: transform 0.3s ease;\n}\n\n.header-logo:hover {\n    transform: scale(1.08) rotate(-4deg);\n}\n\nheader h1 {\n    font-family: var(--font-serif);\n    font-size: 4rem;\n    font-weight: 700;\n    color: var(--text-primary);\n    letter-spacing: -0.02em;\n    /* no margin-bottom here — the row handles spacing */\n    margin-bottom: 0;\n}\n\nheader p {\n    color: var(--text-secondary);\n    font-size: 1.125rem;\n    font-weight: 400;\n    letter-spacing: 0.05em;\n    text-transform: uppercase;\n}\n\n.marker-highlight {\n    position: relative;\n    text-decoration: none;\n    color: var(--text-primary);\n    font-weight: 700;\n    display: inline-block;\n    padding: 0 4px;\n}\n\n.marker-highlight::after {\n    content: \"\";\n    position: absolute;\n    left: -2%;\n    bottom: 2px;\n    width: 104%;\n    height: 1.25em;\n    background: var(--accent-blue);\n    /* Tagesschau Blue */\n    z-index: -1;\n    transform: rotate(-1deg);\n    opacity: 0.2;\n    /* Light blue marker look */\n    border-radius: 20% 80% 30% 70% / 10% 40% 60% 90%;\n    /* Messy organic shape */\n    transition: all 0.3s ease;\n}\n\n.marker-highlight:hover::after {\n    opacity: 0.4;\n    transform: rotate(0deg) scale(1.05);\n}\n\n/* Search Section - Centered & Airy */\n#search-section {\n    position: fixed;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    width: 100%;\n    max-width: 1050px;\n    /* Wider layout */\n    z-index: 1000;\n    transition: all 0.7s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n#search-wrapper {\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    gap: 3.5rem;\n    /* Generous space between search bar and pills */\n    align-items: center;\n}\n\n.search-top #search-section {\n    position: relative;\n    top: 0;\n    left: 0;\n    transform: none;\n    margin: 0 auto 4rem;\n    max-width: 100%;\n}\n\n.search-top header {\n    transform: translateY(-20px);\n    opacity: 0.5;\n    margin-bottom: 1rem;\n}\n\n.search-top .header-logo {\n    width: 36px;\n    height: 36px;\n}\n\n.search-box {\n    width: 100%;\n    display: flex;\n    background: var(--glass-bg);\n    backdrop-filter: var(--glass-blur);\n    border: 1px solid var(--glass-border);\n    border-radius: var(--radius);\n    padding: 8px;\n    box-shadow: var(--shadow-subtle);\n    transition: all 0.3s ease;\n}\n\n.search-box:focus-within {\n    background: #fff;\n    box-shadow: var(--shadow-modal);\n    border-color: var(--text-primary);\n}\n\n.search-box input {\n    flex: 1;\n    background: transparent;\n    border: none;\n    padding: 16px 24px;\n    color: var(--text-primary);\n    font-size: 1.25rem;\n    font-family: var(--font-serif);\n    outline: none;\n}\n\n.search-box input::placeholder {\n    color: var(--text-muted);\n}\n\n/* Centered Pill Tags */\n.tags-list {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 0.75rem 1rem;\n    justify-content: center;\n    width: 100%;\n}\n\n.tag {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    background: var(--glass-bg);\n    backdrop-filter: var(--glass-blur);\n    padding: 4px 12px 4px 10px;\n    border-radius: var(--radius-pill);\n    font-family: var(--font-sans);\n    font-size: 0.85rem;\n    font-weight: 500;\n    color: var(--text-primary);\n    border: 1.5px solid var(--glass-border);\n    transition: all 0.2s;\n    cursor: default;\n}\n\n.tag:hover {\n    border-color: var(--tag-color, var(--text-muted));\n    background: var(--glass-bg);\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);\n}\n\n.tag-color-dot {\n    width: 10px;\n    height: 10px;\n    border-radius: 50%;\n    flex-shrink: 0;\n}\n\n.tag-remove {\n    cursor: pointer;\n    font-size: 1rem;\n    line-height: 1;\n    color: var(--text-muted);\n    transition: color 0.2s;\n    display: flex;\n    align-items: center;\n    margin-left: 2px;\n}\n\n.tag-remove:hover {\n    color: var(--accent);\n}\n\n/* Chart Container Card */\n#chart-section {\n    background: var(--glass-bg);\n    backdrop-filter: var(--glass-blur);\n    border: 1px solid var(--glass-border);\n    border-radius: var(--radius);\n    padding: 3rem;\n    box-shadow: var(--shadow-subtle);\n    opacity: 0;\n    transform: translateY(30px);\n    transition: all 0.8s cubic-bezier(0.16, 1, 0.3, 1);\n}\n\n#chart-section.visible {\n    opacity: 1;\n    transform: translateY(0);\n}\n\n.chart-header {\n    margin-bottom: 3rem;\n    display: flex;\n    justify-content: space-between;\n    align-items: flex-start;\n}\n\n.chart-header h2 {\n    font-family: var(--font-serif);\n    font-size: 2rem;\n    font-weight: 700;\n    color: var(--text-primary);\n    position: relative;\n}\n\n.chart-header h2::after {\n    content: '';\n    display: block;\n    width: 40px;\n    height: 4px;\n    background: var(--accent);\n    margin-top: 10px;\n}\n\n#close-chart {\n    background: transparent;\n    border: none;\n    color: var(--text-muted);\n    cursor: pointer;\n    width: 40px;\n    height: 40px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    transition: all 0.2s;\n    font-size: 2rem;\n}\n\n#close-chart:hover {\n    color: var(--text-primary);\n}\n\n#chart-container {\n    width: 100%;\n    height: 500px;\n}\n\n/* D3 Professional Visualization - Light Mode High Contrast */\n.line {\n    fill: none;\n    stroke-width: 2;\n    stroke-linecap: round;\n}\n\n.dot {\n    cursor: pointer;\n    stroke: #fff;\n    stroke-width: 1.5px;\n}\n\n.dot:hover {\n    r: 6;\n    stroke-width: 2px;\n}\n\n.axis-label {\n    fill: var(--text-muted);\n    font-size: 0.85rem;\n    font-family: var(--font-sans);\n    font-weight: 500;\n}\n\n.grid line {\n    stroke: #f0f0f0;\n}\n\n.tick text {\n    fill: var(--text-secondary);\n    font-size: 0.85rem;\n    font-family: var(--font-sans);\n    font-weight: 500;\n}\n\n.x-axis path,\n.y-axis path {\n    stroke: var(--border-light);\n}\n\n/* Brush Tool */\n.brush .selection {\n    fill: var(--text-primary);\n    fill-opacity: 0.05;\n    stroke: var(--text-primary);\n    stroke-opacity: 0.2;\n    stroke-width: 1px;\n}\n\n/* Loader Styling */\n#loader {\n    position: fixed;\n    bottom: 3rem;\n    right: 3rem;\n    background: #fff;\n    padding: 16px 32px;\n    border-radius: var(--radius-pill);\n    border: 1px solid var(--border-light);\n    box-shadow: var(--shadow-modal);\n    display: flex;\n    align-items: center;\n    gap: 1rem;\n    z-index: 10000;\n}\n\n#loader p {\n    font-weight: 600;\n    color: var(--text-primary);\n    font-size: 0.95rem;\n}\n\n.spinner {\n    width: 18px;\n    height: 18px;\n    border: 2px solid #eee;\n    border-top-color: var(--accent);\n    border-radius: 50%;\n    animation: spin 0.8s infinite linear;\n}\n\n.hidden {\n    display: none !important;\n}\n\n@keyframes spin {\n    to {\n        transform: rotate(360deg);\n    }\n}\n\n@media (max-width: 768px) {\n    header h1 {\n        font-size: 2.5rem;\n    }\n\n    #chart-section {\n        padding: 1.5rem;\n    }\n\n    #chart-container {\n        height: 350px;\n    }\n}\n\n/* Footer Styles */\nfooter {\n    margin-top: auto;\n    padding: 2rem 0;\n    /* Reduced height */\n    border-top: 1px solid var(--border-light);\n    color: var(--text-muted);\n    font-size: 0.85rem;\n}\n\n.footer-grid {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    /* Centered vertically */\n    gap: 2rem;\n}\n\n.footer-left p {\n    margin-bottom: 0.25rem;\n    /* Less space */\n}\n\n.footer-center {\n    flex: 1;\n    max-width: 400px;\n}\n\n.newsletter-input {\n    border: 1px solid var(--glass-border);\n    border-radius: var(--radius);\n    /* Independent rounded borders */\n    padding: 8px 16px;\n    font-family: var(--font-sans);\n    outline: none;\n    width: 200px;\n    transition: all 0.2s;\n    margin-right: 8px;\n    /* Added space between united group items earlier? No, let's separate them if we want 'same borders' */\n}\n\n.newsletter-input:focus {\n    border-color: var(--text-primary);\n}\n\n.btn-subscribe {\n    background: var(--accent-blue);\n    color: white;\n    border: 1px solid var(--accent-blue);\n    border-radius: var(--radius);\n    padding: 8px 20px;\n    font-weight: 600;\n    cursor: pointer;\n    transition: all 0.2s;\n}\n\n.btn-subscribe:hover {\n    background: #003a61;\n}\n\n.dsgvo-wrapper {\n    margin-top: 8px;\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    font-size: 0.8rem;\n}\n\n.dsgvo-link {\n    text-decoration: underline;\n    cursor: pointer;\n}\n\n/* Modal Styling */\n.custom-modal {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background: rgba(0, 0, 0, 0.4);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    z-index: 10000;\n}\n\n.custom-modal .modal-content {\n    background: white;\n    padding: 2rem;\n    border-radius: var(--radius);\n    max-width: 500px;\n    width: 90%;\n    box-shadow: var(--shadow-modal);\n}\n\n.subtitle-modal-content {\n    max-width: 800px !important;\n    max-height: 80vh;\n    display: flex;\n    flex-direction: column;\n}\n\n.subtitle-body {\n    overflow-y: auto;\n    font-family: var(--font-sans);\n    line-height: 1.8;\n    font-size: 1.1rem;\n    color: var(--text-primary);\n    padding-right: 1rem;\n}\n\n/* Marker highlight within subtitle text */\n.text-marker {\n    position: relative;\n    padding: 0 4px;\n    font-weight: 700;\n    z-index: 1;\n}\n\n.text-marker::after {\n    content: \"\";\n    position: absolute;\n    left: -2px;\n    bottom: 0px;\n    width: calc(100% + 4px);\n    height: 1.2em;\n    background: var(--accent-blue);\n    opacity: 0.25;\n    z-index: -1;\n    transform: rotate(-0.5deg);\n    border-radius: 2px 4px 1px 3px;\n}\n\n.modal-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 1.5rem;\n}\n\n.btn-close {\n    background: none;\n    border: none;\n    font-size: 2rem;\n    cursor: pointer;\n    color: var(--text-muted);\n}\n\n.author-link {\n    color: var(--text-primary);\n    text-decoration: none;\n    font-weight: 600;\n}\n\n.author-link:hover {\n    text-decoration: underline;\n}\n\n.disclaimer {\n    font-style: italic;\n    font-size: 0.75rem;\n}\n\n.text-muted {\n    font-family: var(--font-sans);\n    line-height: 1.6;\n}\n\n.text-muted b {\n    color: var(--text-secondary);\n}\n\n.text-muted a {\n    color: var(--text-muted);\n    text-decoration: underline;\n    text-underline-offset: 2px;\n}\n\n.text-muted a:hover {\n    color: var(--accent-blue);\n}\n\n@media (max-width: 900px) {\n    .footer-grid {\n        flex-direction: column;\n        text-align: center;\n        gap: 1.5rem;\n    }\n\n    .footer-center {\n        max-width: 100%;\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
